import { Component, Input, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.css']
})
export class LoadingAnimationComponent implements OnInit {

  @Input() isRouting?: boolean = false;
  @Input() height?:number;
  @Input() width?:number;
  @Input() margin?:string;
  @Input() background?: string;
  @Input() rotate?: string;

  private routerSubscription: Subscription = new Subscription();

  constructor(private router:Router) { }

  ngOnInit(): void {
    this.routerSubscription.add(
      this.router.events.subscribe(event => {
        if(event instanceof NavigationStart){
          this.isRouting = true;
        }else if(event instanceof NavigationEnd){
          this.isRouting = false;
        }else if(event instanceof NavigationCancel){
          this.isRouting = false;
        }
      })
    );
  }

  ngOnDestroy(){
    this.routerSubscription.unsubscribe();
  }

}
